import { render, staticRenderFns } from "./snp.vue?vue&type=template&id=2bdef20e&"
import script from "./snp.vue?vue&type=script&lang=js&"
export * from "./snp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports